import { apiService } from './api';
import { SageTaxType } from '../types/sageTaxType';
import { SAGE_COMPANY_ID } from '../constants/sage';

export const sageTaxTypeService = {
  getAllLocal: async () => {
    return apiService.get<SageTaxType[]>('/sage/tax-types/local');
  },

  getAllFromSage: async () => {
    return apiService.get<SageTaxType[]>('/sage/tax-types', { companyId: SAGE_COMPANY_ID });
  },

  syncFromSage: async () => {
    return apiService.post<SageTaxType[]>(`/sage/tax-types/sync?companyId=${SAGE_COMPANY_ID}`);
  },
};
